import React from 'react';
import { Link } from 'react-router-dom';

/** Footer.jsx — beige-theme redesign. Drop-in replacement. Self-contained. */
const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="cai-ft2">
      <div className="cai-ft2-top">
        <div>
          <div className="cai-ft2-brand">
            <svg width="32" height="32" viewBox="0 0 100 100" fill="none">
              <rect x="2" y="2" width="96" height="96" rx="26" fill="#C0492A" />
              <line x1="50" y1="20" x2="50" y2="31" stroke="#fff" strokeWidth="4.5" strokeLinecap="round" />
              <circle cx="50" cy="15" r="5.5" fill="#1A1A18" />
              <rect x="25" y="31" width="50" height="44" rx="15" fill="#fff" />
              <rect x="34" y="42" width="32" height="22" rx="9" fill="#1A1A18" />
              <circle cx="44.5" cy="53" r="4" fill="#5E6B39" />
              <circle cx="57.5" cy="53" r="4" fill="#5E6B39" />
            </svg>
            <span className="cai-ft2-name">Custodian<span style={{ color: '#E0794F' }}>AI</span> Automation</span>
          </div>
          <p className="cai-ft2-desc">AI automation for growing businesses — voice agents, workflow automation, document processing, and systems integration. Managed 24/7.</p>
        </div>
        <div>
          <h4 className="cai-ft2-h4">Quick Links</h4>
          <a className="cai-ft2-link" href="#how-it-works">How It Works</a>
          <a className="cai-ft2-link" href="#use-cases">Use Cases</a>
          <a className="cai-ft2-link" href="#features">Features</a>
          <Link className="cai-ft2-link" to="/case-studies">Case Studies</Link>
          <a className="cai-ft2-link" href="#booking">Book Demo</a>
        </div>
        <div>
          <h4 className="cai-ft2-h4">Products</h4>
          <Link className="cai-ft2-link" to="/tradiepro">TradiePro</Link>
          <Link className="cai-ft2-link" to="/rostering">Rostering Automation</Link>
          <Link className="cai-ft2-link" to="/products">All Products</Link>
        </div>
        <div>
          <h4 className="cai-ft2-h4">Contact Us</h4>
          <div className="cai-ft2-contact">✉️&nbsp;&nbsp;hello@custodianai.co.nz</div>
          <div className="cai-ft2-contact">📞&nbsp;&nbsp;+64 210 851 048</div>
          <div className="cai-ft2-contact">📍&nbsp;&nbsp;Auckland, New Zealand</div>
        </div>
      </div>
      <div className="cai-ft2-bottom">
        <span>© {year} Custodian AI Automation. All rights reserved.</span>
        <span>
          <Link className="cai-ft2-legal" to="/privacy">Privacy Policy</Link>
          &nbsp;&nbsp;•&nbsp;&nbsp;
          <Link className="cai-ft2-legal" to="/terms">Terms of Service</Link>
        </span>
      </div>
      <style>{`
        .cai-ft2 { background: #1A1A18; color: #fff; margin-top: 96px; }
        .cai-ft2-top { max-width: 1200px; margin: 0 auto; padding: 64px 40px 0; display: grid; grid-template-columns: 1.6fr 1fr 1fr 1.2fr; gap: 40px; }
        .cai-ft2-brand { display: flex; align-items: center; gap: 11px; margin-bottom: 16px; }
        .cai-ft2-name { font-size: 16px; font-weight: 800; }
        .cai-ft2-desc { font-size: 14px; line-height: 1.6; color: #9A958A; max-width: 300px; margin: 0; }
        .cai-ft2-h4 { font-size: 13px; letter-spacing: 0.06em; text-transform: uppercase; color: #7C786E; margin: 0 0 16px; }
        .cai-ft2-link { display: block; font-size: 14px; color: #C5C0B6; margin-bottom: 11px; text-decoration: none; transition: color .15s; }
        .cai-ft2-link:hover { color: #fff; }
        .cai-ft2-contact { font-size: 14px; color: #C5C0B6; margin-bottom: 11px; }
        .cai-ft2-bottom { max-width: 1200px; margin: 44px auto 0; padding: 22px 40px; border-top: 1px solid #2E2C28; display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; font-size: 13px; color: #7C786E; }
        .cai-ft2-legal { color: #7C786E; text-decoration: none; }
        .cai-ft2-legal:hover { color: #fff; }
        @media (max-width: 900px) { .cai-ft2-top { grid-template-columns: 1fr 1fr; padding: 48px 22px 0; } }
      `}</style>
    </footer>
  );
};

export default Footer;
